import React, { useState, useContext } from 'react'
import Login from './login'
import { LoginProvider } from './login-context'
import BankIdSignup from './bankid-signup'
import MessageContext from '../message/message-context'
import api from '../../api'

const LoginPage: React.FC = () => {
  const [ssn, setSsn] = useState('')
  const [bankIdSignup, setBankIdSignup] = useState(false)
  const { setErrorMessage } = useContext(MessageContext)
  const controller = new window.AbortController()
  const signal = controller.signal

  const authenticate = async (ssn: string) => {
    try {
      ssn = ssn.trim()
      if (ssn.match(/^\d{12}$/)) {
        const res = await api.post(
          '/bank-id/authenticate',
          {
            personalNumber: ssn,
          },
          { signal },
        )

        if (res.status === 200) {
          const data = res.data
          return data.data
        } else {
          setErrorMessage('Något gick fel, var god och försök igen.')
          return false
        }
      } else {
        setErrorMessage('Personnumret måste vara i formatet ÅÅÅÅMMDDXXXX.')
        return false
      }
    } catch (e) {
      console.log(e)
      setErrorMessage('Inloggning misslyckades, var god och försök igen.')
      return false
    }
  }

  const cancelAuthenticate = async () => {
    try {
      controller.abort()
    } catch (e) {
      setErrorMessage('Något gick fel. Var god vänta.')
    }
  }

  const tabSelector = () => {
    switch (bankIdSignup) {
      case true:
        return <BankIdSignup />
      default:
        return <Login />
    }
  }

  return (
    <LoginProvider
      value={{ ssn, setSsn, authenticate, bankIdSignup, setBankIdSignup, cancelAuthenticate }}
    >
      {tabSelector()}
    </LoginProvider>
  )
}

export default LoginPage
